import { CardType } from '../../../constants/payments';

const convertToYYYYMMDD = (date: Date) => {
  if (date.getFullYear() < 2000) {
    date.setFullYear(date.getFullYear() + 100);
  }
  return date.toISOString().split('T')[0];
};

const getDate = () => {
  const date = new Date();
  return convertToYYYYMMDD(date).replace(/-/g, '_');
};

const parseBlob = (blobText: string, contentType: string): Blob => {
  return new Blob([blobText], { type: contentType });
};

const saveToFile = (res: Blob | MediaSource, fileName: string): void => {
  const link = document.createElement('a');
  document.body.appendChild(link);
  link.setAttribute('style', 'display: none');

  const url = (window.URL || window.webkitURL).createObjectURL(res);
  link.href = url;
  link.download = fileName;
  link.click();

  setTimeout(() => {
    window.URL.revokeObjectURL(url);
    link.remove();
  }, 100);
};

const printToFile = (res: Blob | MediaSource, fileName: string): void => {
  const link = document.createElement('a');
  document.body.appendChild(link);
  link.setAttribute('style', 'display: none');
  const url = (window.URL || window.webkitURL).createObjectURL(res);
  link.href = url;
  link.download = fileName;
  link.click();

  setTimeout(() => {
    link.remove();
  }, 100);
};

export const saveFile = (data: string, fileName: string) => {
  const blob = parseBlob(data, 'data:application/csv,');
  return saveToFile(blob, fileName);
};

export const printFile = (data: string, fileName: string) => {
  const blob = parseBlob(data, 'data:application/pdf,');
  return printToFile(blob, fileName);
};

export const getFileName = (cardType: CardType) => {
  switch (cardType) {
    case CardType.CREDIT_CARD: {
      return `THD_CREDITCARDS_${getDate()}`;
    }
    case CardType.GIFT_CARD: {
      return `THD_GIFTCARDS_${getDate()}`;
    }
    case CardType.CHECKING_ACCOUNT: {
      return `THD_CHECKINGACCTS_${getDate()}`;
    }
    default:
      return '';
  }
};
